var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonLocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.3 68.3",
    style: {
      enableBackground: "new 0 0 56.3 68.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#808080;}\r\n\t.st1{fill:#CCCCCC;}\r\n\t.st2{fill:#B3B3B3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_153_",
    className: "st0",
    d: "M43.1,12H11.5C5.1,12,0,17.1,0,23.5v33.3c0,6.3,5.1,11.5,11.5,11.5h33.3 c6.3,0,11.5-5.1,11.5-11.5V25.2C56.3,17.9,50.4,12,43.1,12L43.1,12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    className: "st1",
    d: "M47,52.2H9.4c-2.9,0-5.2-2.4-5.2-5.2V9.4c0-2.9,2.4-5.2,5.2-5.2H47c2.9,0,5.2,2.4,5.2,5.2V47 C52.2,49.8,49.8,52.2,47,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_148_",
    className: "st2",
    d: "M43.1,6c3.9,0,7.2,3.2,7.2,7.2v32.3c0,2.7-2.2,4.8-4.8,4.8H10.8c-2.7,0-4.8-2.2-4.8-4.8V10.8 C6,8.2,8.2,6,10.8,6H43.1 M43.1,0H10.8C4.8,0,0,4.8,0,10.8v34.7c0,6,4.8,10.8,10.8,10.8h34.7c6,0,10.8-4.8,10.8-10.8V13.2 C56.3,5.9,50.4,0,43.1,0L43.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M33.6,26.1v-3.3l-2.8-3.4h-5.7l-2.6,3.3v3.3h-2.2v10.9h15.6V26.1H33.6z M24.7,23.5l1.4-1.9h3.7 l1.6,1.9v2.5h-6.7V23.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLocked);
export default __webpack_public_path__ + "static/media/button_locked.18551beb26b5121c9a56702702a365bc.svg";
export { ForwardRef as ReactComponent };